<template>
  <div
    :style="{ 'z-index': getPopupZindex }"
    :class="{'reservation-rules-problem-overlay': true, 'is-visible': isVisible }">
    <div class="reservation-rules-problem">
      <a
        href="#"
        class="reservation-rules-problem-popup-close"
        @click.prevent="popupClose">
        &times;
      </a>

      <h2>
        {{ title }}
      </h2>

      <div v-pure-html="desc"></div>

      <p v-if="workers.length">
        <select v-model="selectedWorker">
          <option key="worker-item-00" value="0">
            {{ $t('reservationRulesProblemPopup.selectWorker') }}
          </option>
          <option
            v-for="(worker, index) of workers"
            :value="worker.id"
            :key="'worker-item-' + index">
            {{ worker.name }}
          </option>
        </select>
      </p>

      <btn
        @click.native="ok"
        type="popup-left danger">
        {{ okLabel }}
      </btn>

      <btn
        @click.native="cancel"
        type="popup-right">
        {{ cancelLabel }}
      </btn>
    </div>
  </div>
</template>

<script>
import PopupZindex from './../mixins/PopupZindex';

export default {
  name: 'confirm',
  mixins: [
    PopupZindex
  ],
  data () {
    return {
      isVisible: false,
      type: '',
      title: '',
      desc: '',
      message: '',
      okLabel: '',
      cancelLabel: '',
      value: '',
      workers: [],
      okClick: false,
      cancelClick: false,
      selectedWorker: 0
    };
  },
  mounted () {
    this.$bus.$on('reservation-rules-problem-display', this.show);
  },
  methods: {
    ok () {
      if (this.okClick) {
        this.okClick(this.selectedWorker);
      }

      this.isVisible = false;
    },
    show (config) {
      this.isVisible = true;
      this.type = config.type || '';
      this.message = config.message || '';
      this.workers = config.workers || [];
      this.okClick = config.okClick || false;
      this.cancelClick = config.cancelClick || false;
      this.setContent();
      this.increasePopupZindex();
    },
    setContent () {
      if (this.type === 'no-free-workers') {
        this.title = this.$t('reservationRulesProblemPopup.noFreeWorkersTitle');
        this.desc = this.$t('reservationRulesProblemPopup.noFreeWorkersDesc');
        this.okLabel = this.$t('reservationRulesProblemPopup.noFreeWorkersOkButton');
        this.cancelLabel = this.$t('reservationRulesProblemPopup.noFreeWorkersCancelButton');
      } else if (this.type === 'free-workers') {
        this.title = this.$t('reservationRulesProblemPopup.selectedWorkerIsUnavailableTitle');
        this.desc = this.$t('reservationRulesProblemPopup.selectedWorkerIsUnavailableDesc');
        this.okLabel = this.$t('reservationRulesProblemPopup.selectedWorkerIsUnavailableOkButton');
        this.cancelLabel = this.$t('reservationRulesProblemPopup.selectedWorkerIsUnavailableCancelButton');
      } else if (this.type === 'other-rules') {
        this.title = this.$t('reservationRulesProblemPopup.reservationNotMeetRulesTitle');
        this.desc = this.$t('reservationRulesProblemPopup.reservationNotMeetRulesDesc') + this.message;
        this.okLabel = this.$t('reservationRulesProblemPopup.reservationNotMeetRulesOkButton');
        this.cancelLabel = this.$t('reservationRulesProblemPopup.reservationNotMeetRulesCancelButton');
      }
    },
    popupClose () {
      this.isVisible = false;
      this.removePopupZindex();
    },
    cancel () {
      if (this.cancelClick) {
        this.cancelClick();
      }

      this.popupClose();
    }
  },
  beforeDestroy () {
    this.$bus.$off('reservation-rules-problem-display', this.show);
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.reservation-rules-problem {
  background: $color-light;
  border-radius: $border-radius-small;
  box-shadow: 0 5px 5px rgba(0, 0, 0, .25);
  left: 50%;
  padding: 2rem 2rem 6rem 2rem;
  position: fixed;
  top: 50%;
  transform: translateX(-50%) translateY(-33.333333%);
  transition: transform .25s ease-out;
  width: 48rem;
  will-change: transform;

  &-overlay {
    background: rgba(0, 0, 0, .25);
    height: 100%;
    left: 0;
    opacity: 0;
    pointer-events: none;
    position: fixed;
    top: 0;
    transition: opacity .25s ease-out;
    width: 100vw;
    will-change: opacity;

    &.is-visible {
      opacity: 1;
      pointer-events: auto;

      .confirm {
        transform: translateX(-50%) translateY(-50%);
      }
    }
  }

  &-popup-close {
    background: $color-danger;
    border-radius: 50%;
    color: $color-light;
    font-size: 3.6rem;
    font-weight: bold;
    height: 3.6rem;
    line-height: 3.5rem;
    position: absolute;
    right: -1.8rem;
    text-align: center;
    top: -1.8rem;
    width: 3.6rem;
  }

  h2 {
    font-weight: 400;
    margin: 0 0 2rem 0;
  }

  p {
    color: $color-text;
  }

  .button-popup-left {
    border-radius: 0 0 0 $border-radius-small;
  }

  .button-popup-right {
    border-radius: 0 0 $border-radius-small 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/ReservationRulesProblemPopup.vue